<template>
  <v-chip v-bind="$attrs" label>
    <span v-if="title" class="font-weight-bold pr-1 text-capitalize">{{ title }}: </span>
    <v-icon v-if="icon" class="mr-1" :small="!largeIcon" :color="iconColor">{{ icon }}</v-icon>
    <span v-html="text" />
    <v-menu v-model="menu" offset-y max-width="400px" max-height="300px" :close-on-content-click="closeOnContentClick" v-if="$slots.actions">
      <template v-slot:activator="{ on }">
        <v-btn small icon v-on="on">
          <v-icon>
            arrow_drop_down
          </v-icon>
        </v-btn>
      </template>
      <v-list v-if="menu" dense>
        <slot name="actions" />
      </v-list>
    </v-menu>
  </v-chip>
</template>

<script>
  export default {
    props: {
      title: String,
      icon: String,
      iconColor: {
        type: String,
        default: '',
      },
      text: String,
      largeIcon: Boolean,
      closeOnContentClick: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      menu: false,
    }),
  }
</script>